/**
 * Formata um CNPJ para exibição (XX.XXX.XXX/XXXX-XX)
 * @param {string|null|undefined} value - CNPJ a ser formatado
 * @param {string} fallback - Valor a retornar se inválido (padrão: 'N/I')
 * @returns {string} CNPJ formatado ou fallback
 */
export function formatCnpj(value, fallback = 'N/I') {
  if (!value) {
    return fallback;
  }

  const cleaned = String(value).replace(/[.\-/]/g, '');

  if (cleaned.length !== 14) {
    return String(value);
  }

  return cleaned.replace(
    /^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})(\d{4})(\d{2})$/i,
    '$1.$2.$3/$4-$5',
  );
}
